<template lang="pug">
.meta-number
  .meta-number__value {{ value }}
  .meta-number__label {{ label }}
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.meta-number {
  display: flex;
  flex-direction: column;
  gap: 8px;
  &__value {
    font-size: 40px;
    line-height: 100%;
    color: $--color-text-regular;
  }
  &__label {
    font-size: 16px;
    line-height: 150%;
    color: $--color-text-secondary;
  }
}
</style>
